import { Button, Group } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";

interface SmartSuggestionProps {
  extractedValue: string;
  onAdd: () => void;
  isLoading?: boolean;
}

export default function SmartSuggestion({
  extractedValue,
  onAdd,
  isLoading = false,
}: SmartSuggestionProps) {
  return (
    <Group justify="flex-start" mt={2}>
      <Button
        variant="light"
        size="compact-xs"
        color="blue"
        leftSection={<IconPlus size={10} />}
        onClick={onAdd}
        loading={isLoading}
        styles={{ root: { fontSize: 10, padding: "0 6px" } }}
      >
        Add &quot;{extractedValue}&quot;
      </Button>
    </Group>
  );
}
